import React from 'react';
import { usePrerequisites } from "../contexts/Prerequisites";
import EndoSetupUserTable from '../AppGrid/EndoSetupUserTable';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';
import connectionService from '../services/Connection';
import consts from '../consts';
import catAdminUtil from '../util/catAdminUtils';

const EndoSetupUser = () => {
	const [{ strings }] = usePrerequisites();
	return <CommonBreadCurmb
		docTitle={strings.EndoSetupUser}
		breadcrumbs={[{ text: strings.EndoSetupUser }]}
		Component={EndoSetupUserTable}
		handleSubmit={catAdminUtil.handleOnSubmit}
		maxCount={consts.maxUserCount}
		message={strings.UserCountWarning}
		apiUrl={connectionService.EndoSetupUser}
		navigateUrl={"/endoSetupUser"}
	/>
}

export default EndoSetupUser;